import { BUSINESS_UUID } from '../../utils/constants';
import { checkValue } from '../../utils';

/* eslint-disable import/prefer-default-export */
// disabled so that this selector keeps the same format as other selectors
const soleBusinessType = 'SOLE TRADER';

export const isSoleBusinessType = (state) => {
  if (!state.dataCapture.get('businessTypeField')) {
    return false;
  }

  return state.dataCapture.get('businessTypeField').toUpperCase() === soleBusinessType;
};

export const businessId = (state) => state.dataCapture.get(BUSINESS_UUID);

export const getBusinessData = (state) => {
  return state.dataCapture.toJS();
};
export const getCustomerData = (state) => {
  if (!state.dataCapture) {
    return false;
  }
  return state.dataCapture.toJS();
};

export const marketingLoader = (state) => state.dataCapture.get('marketingLoader');

export const getRegisterAddress = (state) => {
  const customerAddress = getRegisterAddressObject(state);
  return customerAddress ? generateAddress(customerAddress) : '';
};

export const getAddressByType = (state, type) => {
  const customerAddress = getAddressObjectByType(state, type);
  return customerAddress && customerAddress.uk_address
    ? generateAddress(customerAddress.uk_address)
    : customerAddress && customerAddress.international_address
    ? generateInternationalAddress(customerAddress.international_address)
    : '';
};

export const getRegisterAddressObject = (state) => {
  let customerAddress = state.dataCapture ? state.dataCapture.get('customerData') : '';
  customerAddress = customerAddress ? customerAddress.toJS() : '';
  return customerAddress &&
    customerAddress.business_details &&
    customerAddress.business_details.registered_company &&
    customerAddress.business_details.registered_company.uk_address
    ? customerAddress.business_details.registered_company.uk_address
    : '';
};

export const getAddressObjectByType = (state, type) => {
  let customerAddress = state.dataCapture ? state.dataCapture.get('customerData') : '';
  customerAddress = customerAddress ? customerAddress.toJS() : '';
  if (
    customerAddress &&
    customerAddress.business_details &&
    customerAddress.business_details.addresses
  ) {
    return customerAddress.business_details.addresses.filter((v) => {
      return v.type && v.type.toLowerCase() === type;
    })[0];
  }
  return '';
};

export const getEditClickByType = (state, type) => {
  const dc = state.dataCapture ? state.dataCapture.toJS() : '';
  return dc ? dc[`${type}EditClick`] : true;
};

/* eslint-disable complexity */
const generateAddress = (address) => {
  const houseNo = (address.hasOwnProperty('house_number') && address.house_number) || '';
  const addressPrefix = (address.hasOwnProperty('address_prefix') && address.address_prefix) || '';
  const street = (address.hasOwnProperty('street') && address.street) || '';
  const city = (address.hasOwnProperty('city') && address.city) || '';
  const postcode = (address.hasOwnProperty('postal_code') && address.postal_code) || '';
  const county = (address.hasOwnProperty('county') && address.county) || '';
  const houseName = (address.hasOwnProperty('house_name') && address.house_name) || '';
  const addressLine2 = (address.hasOwnProperty('house_name') && address.address_line2) || '';
  const organisationName =
    (address.hasOwnProperty('organisation_name') && address.organisation_name) || '';
  const firstLineAddress = !houseName && organisationName ? organisationName : houseName;
  const secondLineAddress = !street && addressLine2 ? addressLine2 : street;

  return `${checkValue(`${addressPrefix} ${firstLineAddress}`)}${checkValue(
    `${houseNo} ${secondLineAddress}`
  )}${checkValue(city)}${checkValue(county)}${checkValue(postcode).replace(',', '')}`;
};

const generateInternationalAddress = (address) => {
  if (address) {
    return `${checkValue(address.address_line1)}${checkValue(address.address_line2)}${checkValue(
      address.address_line3
    )}${checkValue(address.address_line4)}${checkValue(address.country)}`;
  }
  return '';
};
